import {Icon, IconName} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {VisualHistoryEventType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  BLUE,
  BLUE_LIGHTER,
  GREEN_DARK,
  GREEN_LIGHTER,
  PURPLE,
  PURPLE_LIGHT,
  RED,
  RED_LIGHTER,
  WHITE,
} from 'ui-library/Colors';

interface VisualHistoryEventIconProps {
  eventType: VisualHistoryEventType;
}

interface VisualHistoryEventIconStyle {
  backgroundColor: string;
  iconColor: string;
  iconName: IconName;
}

const EVENT_TYPE_TO_STYLE: {[key in VisualHistoryEventType]: VisualHistoryEventIconStyle} = {
  [VisualHistoryEventType.CREATE]: {
    backgroundColor: GREEN_LIGHTER,
    iconColor: GREEN_DARK,
    iconName: 'plus',
  },
  [VisualHistoryEventType.ADD]: {
    backgroundColor: BLUE_LIGHTER,
    iconColor: BLUE,
    iconName: 'pen',
  },
  [VisualHistoryEventType.REMOVE]: {
    backgroundColor: RED_LIGHTER,
    iconColor: RED,
    iconName: 'trash-can',
  },
  [VisualHistoryEventType.UPDATE]: {
    backgroundColor: PURPLE_LIGHT,
    iconColor: PURPLE,
    iconName: 'arrows-rotate',
  },
};

/**
 * Render an icon representing the type of visual history event.
 * @param eventType
 * @constructor
 */
export default function VisualHistoryEventIcon({eventType}: VisualHistoryEventIconProps): JSX.Element {
  const {backgroundColor, iconColor, iconName} = EVENT_TYPE_TO_STYLE[eventType];
  return (
    <div className={css(styles.iconContainer)}>
      <div className={css(styles.coloredCircle)} style={{backgroundColor}}>
        <Icon className={css(styles.icon)} icon={iconName} style={{color: iconColor}} />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  iconContainer: {
    display: 'flex',
    width: '28px',
    height: '28px',
    backgroundColor: WHITE,
    position: 'absolute',
    left: '-15px',
    top: '8px',
  },
  coloredCircle: {
    display: 'flex',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    margin: 'auto',
  },
  icon: {
    margin: 'auto',
  },
});
